<div class="modal-header">
    <h4 class="modal-title pull-left">{{ 'Reply templates' | translate }}</h4>
    <button
        type="button"
        class="btn btn-icon btn-close btn-transparent"
        [attr.aria-label]="'Close' | translate"
        (click)="close()">
        <sb-inline-svg class="icon icon-close" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
        </sb-inline-svg>
    </button>
</div>
<div class="modal-body">
    @if (replyTemplateService.isReplyTemplatesLoaded) {
        @if (replyTemplateService.replyTemplates.length || replyTemplateService.personalReplyTemplates.length) {
            @if (!isVariablesView) {
                <div>
                    <div class="list-search">
                        <form class="search-box">
                            <input
                                type="text"
                                class="form-control"
                                name="search-box"
                                required
                                autocomplete="off"
                                [(ngModel)]="keyword"
                                (ngModelChange)="startTextSearch()"
                                placeholder="{{ 'Search' | translate }}" />
                            @if (keyword?.length) {
                                <button
                                    class="btn-transparent btn-clear"
                                    type="reset"
                                    [attr.aria-label]="'Reset templates search' | translate">
                                    <sb-inline-svg
                                        class="icon icon-clear"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                                    </sb-inline-svg>
                                </button>
                            }
                        </form>
                    </div>

                    <sb-reply-templates-list
                        [title]="'Personal templates' | translate"
                        (replyTemplateChosenEvent)="chooseTemplate($event)"
                        [templatesTree]="replyTemplateService.personalReplyTemplatesTree">
                    </sb-reply-templates-list>

                    <sb-reply-templates-list
                        [title]="'Community templates' | translate"
                        (replyTemplateChosenEvent)="chooseTemplate($event)"
                        [templatesTree]="replyTemplateService.replyTemplatesTree">
                    </sb-reply-templates-list>
                </div>
            } @else {
                <!--                todo: check does this div needed-->
                <div>
                    @for (variable of variables; track variable; let index = $index; let first = $first) {
                        <div class="form-group">
                            <label class="d-block truncate" for="variable-{{ index }}">{{ variable }}</label>
                            <input
                                id="variable-{{ index }}"
                                class="form-control"
                                [(ngModel)]="variableValues[variable]"
                                placeholder="{{ 'value' | translate }}"
                                (keyup)="updateTemplateText()"
                                [appAutoFocus]="!!first"
                                [focusTimeout]="0"
                                appFocus />
                        </div>
                    }

                    @if (isTextContent) {
                        <textarea class="form-control" readonly rows="4" [(ngModel)]="textWithVariables"> </textarea>
                    } @else {
                        <quill-editor
                            [(ngModel)]="textWithVariables"
                            placeholder=""
                            [readOnly]="true"
                            [modules]="quillConfig"
                            format="html">
                        </quill-editor>
                    }
                </div>
            }
        } @else {
            @if (isAdmin) {
                <p>
                    {{ "You don't have any saved templates yet. Add some templates" | translate }}
                    <a
                        href="{{ environment.settingsUrl }}{{
                            commonDataService.communityName
                        }}/community/reply-templates">
                        {{ 'here' | translate }}
                    </a>
                </p>
            } @else {
                <p>
                    {{
                        "You don't have any saved templates yet. Talk to your administrator to get access to add some."
                            | translate
                    }}
                </p>
            }
        }
    } @else {
        <sb-loader></sb-loader>
    }
</div>
<div class="modal-footer">
    @if (isVariablesView && hasBackButton) {
        <button (click)="back()" type="button" class="btn btn-default pull-left">{{ 'Back' | translate }}</button>
    }
    <span class="flex-fill"></span>
    <button type="button" class="btn btn-default" (click)="close()">{{ 'Cancel' | translate }}</button>
    @if (isVariablesView) {
        <button (click)="add(textWithVariables, selectedTemplate.attachments)" type="button" class="btn btn-primary">
            {{ 'Add' | translate }}
        </button>
    }
</div>
